export const SOLANA_RPC_URL =
  "https://solana-mainnet.g.alchemy.com/v2/WYKQbgegxfO4DfIQdKzjFhh4vFghlXRS";
